import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { request } from "@/shared/api/http";
import { zId, zNumber, zText } from "@/shared/api/schema";

export const meKey = ["me"] as const;

export const calendarTaskSummarySchema = z.looseObject({
  id: zId,
  title: zText,
  description: zText,
  start_date: zText,
  end_date: zText,
  start_time: zText,
  end_time: zText,
  activity: zText,
});

export const meSchema = z
  .object({
    user: z.looseObject({
      id: zId,
      firstname: zText,
      lastname: zText,
      email: z.string(),
      phone: zText,
      birthdate: zText,
      roles: z.array(z.string()),
      all_permissions: z.array(z.string()),
      picture_url: zText,
      leads_count: zNumber,
      cold_calls_count: zNumber,
      farmings_count: zNumber,
      pipelines_count: zNumber,
      closed_won_count: zNumber,
      closed_lost_count: zNumber,
      calendar_tasks: z.array(calendarTaskSummarySchema).default([]),
    }),
  })
  .transform((data) => data.user);

export type Me = z.infer<typeof meSchema>;

export function fetchMe(signal?: AbortSignal): Promise<Me> {
  return request("me", { schema: meSchema, ...(signal ? { signal } : {}) });
}

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: meKey,
    queryFn: ({ signal }) => fetchMe(signal),
    enabled,
    staleTime: 5 * 60_000,
  });
}
